<template>
    <v-combobox
        v-model="value"
        :label="label"
        :items="items"
        :loading="loading"
        :append-icon="icon"
        item-text="name"
        item-value="id"
        :multiple="multiple"
        clearable>
      <template #selection="{ item }">
        <v-chip :color="color">{{item.name}}</v-chip>
      </template>
    </v-combobox>
</template>

<script>
export default {
  props: [ 'modelValue', 'items', 'loading', 'label', 'icon', 'color', 'multiple' ],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    isAnyFilter () {
      return this.value.length > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/CommonComboEdit.vue